import { useEffect, useState } from "react";
import taskService from "../../services/taskService";

const TaskView = ({ task, show, onClose }) => {

    const [comments, setComments] = useState([])

    useEffect(() => {
        fetchComments();
    }, [])

    console.log("comments111===", comments)

    if (!show || !task) {
        return null;
    }
    let parsedTags = [];

    try {
        const tagsData =
            typeof task.tags === "string"
                ? JSON.parse(task.tags)
                : task.tags;

        parsedTags = Array.isArray(tagsData)
            ? tagsData
            : [];
    } catch (error) {
        parsedTags = [];
    }

    const fetchComments = async () => {
        if (!task?.id) return;
        try {
            const data = await taskService.getComments(task.id);
            console.log("COMMENTS RESPONSE===:", data);
            setComments(data?.comments || []);
        } catch (err) {
            console.error("Failed to fetch comments:", err);
            setComments([]);
        }
    };

    return (
        <>

            {/* Header */}
            <div className="selected-task-header bg-[#f9f9fc]">
                <h4 className="text-[1.2rem] font-semibold">Task Details</h4>
                <button
                    type="button"
                    className="text-[2rem] hover:text-red-400 leading-[0]"
                    onClick={onClose}
                >
                    ×
                </button>
            </div>

            {/* Body */}
            <div className="selected-task-body my-3">
                <div className="task-view rounded-b-lg">
                    <div className="flex flex-col gap-6">
                        <div className="bg-white rounded-xl">
                            {/* Title */}
                            <div className="form-group">
                                <label>Title</label>
                                <input
                                    type="text"
                                    value={task.title || ""}
                                    className="form-control"
                                    readOnly
                                />
                            </div>


                            {/* Project & Milestone */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

                                {/* Project */}
                                <div className="form-group">
                                    <label>Project</label>
                                    <input
                                        type="text"
                                        value={
                                            task.project
                                                ? `${task.project.name} (${task.project.code})`
                                                : task.project_id || ""
                                        }
                                        className="form-control"
                                        readOnly
                                    />
                                </div>

                                {/* Milestone */}
                                <div className="form-group">
                                    <label>Milestone</label>
                                    <input
                                        type="text"
                                        value={
                                            task.milestone?.name ||
                                            task.milestone_name ||
                                            ""
                                        }
                                        className="form-control"
                                        readOnly
                                    />
                                </div>
                            </div>

                            {/* Parent / Dates / Hours */}
                            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">

                                {/* Parent Task */}
                                <div className="form-group">
                                    <label>Parent Task</label>
                                    <input
                                        type="text"
                                        value={
                                            task.parent_task?.title ||
                                            task.parent_task_id ||
                                            "No Parent Task"
                                        }
                                        className="form-control"
                                        readOnly
                                    />
                                </div>

                                {/* Start Date */}
                                <div className="form-group">
                                    <label>Start Date</label>
                                    <input
                                        type="date"
                                        value={task.start_date || ""}
                                        className="form-control"
                                        readOnly
                                    />
                                </div>

                                {/* Due Date */}
                                <div className="form-group">
                                    <label>Due Date</label>
                                    <input
                                        type="date"
                                        value={task.due_date || ""}
                                        className="form-control"
                                        readOnly
                                    />
                                </div>

                                {/* Estimated Hours */}
                                <div className="form-group">
                                    <label>Estimated Hours</label>
                                    <input
                                        type="number"
                                        value={task.estimated_hours || 0}
                                        className="form-control"
                                        readOnly
                                    />
                                </div>

                                {/* Completed Hours */}
                                <div className="form-group">
                                    <label>Completed Hours</label>
                                    <input
                                        type="number"
                                        value={task.actual_hours || 0}
                                        className="form-control"
                                        readOnly
                                    />
                                </div>

                                {/* Remaining Hours */}
                                <div className="form-group">
                                    <label>Remaining Hours</label>
                                    <input
                                        type="number"
                                        value={
                                            task.remaining_hours ??
                                            task.remaing_hours ??
                                            0
                                        }
                                        className="form-control"
                                        readOnly
                                    />
                                </div>
                            </div>

                            {/* Description */}
                            <div className="form-group mb-4">
                                <label>Description</label>
                                <div
                                    className="form-control min-h-[100px] overflow-auto"
                                    dangerouslySetInnerHTML={{
                                        __html:
                                            task.description ||
                                            "<p>No description available</p>",
                                    }}
                                />
                            </div>

                            {/* Acceptance Criteria & Discussion */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                {/* Acceptance Criteria */}
                                <div className="form-group">
                                    <label>Acceptance Criteria</label>
                                    <div
                                        className="form-control min-h-[100px] overflow-auto"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                task.acceptance_criteria ||
                                                "<p>No acceptance criteria available</p>",
                                        }}
                                    />
                                </div>

                                {/* Discussion */}
                                <div className="form-group">
                                    <label>Discussion</label>
                                    <div
                                        className="form-control min-h-[100px] overflow-auto"
                                        dangerouslySetInnerHTML={{
                                            __html:
                                                task.discussion ||
                                                "<p>No discussion available</p>",
                                        }}
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-2">
                                <div className="form-group">
                                    <label>Task type</label>
                                    <input
                                        type="text"
                                        value={task.task_type}
                                        className="form-control"
                                        readOnly
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Status</label>
                                    <input
                                        type="text"
                                        value={task.status}
                                        className="form-control"
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="grid grid-cols-2">
                                <div className="form-group">
                                    <label>Priority</label>
                                    <input
                                        type="text"
                                        value={task.priority}
                                        className="form-control"
                                        readOnly
                                    />
                                </div>
                                <div className="form-group">
                                    <label>Assignee ID</label>
                                    <input
                                        type="text"
                                        value={`${task.assignee.first_name} ${task.assignee.last_name}`}
                                        className="form-control"
                                        readOnly
                                    />
                                </div>
                            </div>


                            <div className="grid grid-cols-2">
                                <div className="form-group">
                                    <label>Tags</label>

                                    <div className="flex flex-wrap gap-2 form-control">
                                        {parsedTags.length > 0 ? (
                                            parsedTags.map((tag, index) => (
                                                <span
                                                    key={index}
                                                    className="badge bg-info text-white"
                                                >
                                                    {typeof tag === "object"
                                                        ? tag.name || tag.label || JSON.stringify(tag)
                                                        : tag}
                                                </span>
                                            ))
                                        ) : (
                                            <span className="text-muted">No tags</span>
                                        )}
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>state</label>
                                    <input
                                        type="text"
                                        value={task.state}
                                        className="form-control"
                                        readOnly
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label>Attachments</label>
                                {task.attachments && task.attachments.length > 0 ? (
                                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                                        {task.attachments.map((attachment) => (
                                            <div key={attachment.id} className="border rounded-lg overflow-hidden">
                                                <img
                                                    src={attachment.attachment_url}
                                                    alt={attachment.file_name || "Task attachment"}
                                                    className="img-fluid h-32 mx-auto cursor-pointer pt-2"
                                                    onClick={() =>
                                                        window.open(
                                                            attachment.attachment_url || attachment.attachment_url,
                                                            "_blank"
                                                        )
                                                    }
                                                />
                                                <div className="p-2 text-sm truncate">
                                                    {attachment.file_name || attachment.file_name}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                ) : (<div>No images attached.</div>)}

                                <img src={task.attachments.file_name} />
                            </div>
                            <div className="form-group">
                                <label>Comments</label>
                                <div className="form-control min-h-[100px] overflow-auto">
                                    {comments.length > 0 ? (<div>
                                        {comments.map((comment) => (
                                            <div key={comment.id}>
                                                <div className="flex">
                                                    {comment.user.avatar_url ? (
                                                        <img src={comment.user.avatar_url}
                                                            alt={comment.user?.first_name || "User"}
                                                            className="w-10 h-10 rounded-full object-cover" />
                                                    ) : (
                                                        <div className="w-10 h-10 rounded-full bg-gray-300 flex items-center justify-center">
                                                            {comment.user?.first_name?.charAt(0) || "U"}
                                                        </div>
                                                    )}

                                                    <div>
                                                        <div className="font-semibold">
                                                            {comment.user.file_name} {comment.user.last_name}
                                                        </div>
                                                        <div className="text-sm text-muted">
                                                            {comment.createdAt
                                                                ? new Date(comment.createdAt).toLocaleString()
                                                                : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div 
                                                    className={`my-2 pb-3 ${
                                                        comment.comment ? 'border-b' : 'last:border-b-0'
                                                    }`}
                                                    >
                                                    {comment.comment}
                                                </div>
                                            </div>
                                        ))}
                                    </div>)
                                        : (<div>not comments</div>)}
                                </div>

                                {/* <input
                                    type="text"
                                    value={comments}
                                    className="form-control min-h-[100px] overflow-auto"
                                    readOnly
                                /> */}
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TaskView;